let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aMybP")).then(() => parcelRequire('8c0qm'));